var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBlox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 31,
    viewBox: "0 0 56 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#236334",
    d: "M0 24.778l5.43 3.099v-6.195z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#41813E",
    d: "M5.43 21.682v6.195l5.43-3.099z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#419D46",
    d: "M5.43 27.877l5.43 3.097v-6.195z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#58B146",
    d: "M10.86 30.974l5.432-3.097-5.432-3.099z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005686",
    d: "M10.86 24.779l5.432 3.098v-6.195z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006997",
    d: "M16.291 21.682v6.195l5.432-3.099z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0885BB",
    d: "M21.723 18.585l-5.432 3.097 5.432 3.097z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0099CA",
    d: "M16.291 15.487v6.195l5.432-3.097z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CF1E5C",
    d: "M21.723 12.39l-5.432 3.097 5.432 3.097z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#902C2F",
    d: "M16.291 9.293v6.194l5.432-3.097z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D82333",
    d: "M16.291 9.293L10.86 12.39l5.431 3.097z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2282D",
    d: "M10.86 6.195v6.194l5.432-3.096z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CF323F",
    d: "M10.86 6.195L5.43 9.292l5.43 3.097z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0582D",
    d: "M0 12.39l5.43-3.098L0 6.195z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5722A",
    d: "M0 6.195l5.43 3.097V3.097z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED9B3A",
    d: "M0 0v6.195l5.43-3.098L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5722A",
    d: "M0 12.39l5.43 3.097V9.292z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0582D",
    d: "M5.43 9.292v6.194l5.43-3.096z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#236334",
    d: "M0 24.778l5.43 3.099v-6.195z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#41813E",
    d: "M5.43 21.682v6.195l5.43-3.099z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#419D46",
    d: "M5.43 27.877l5.43 3.097v-6.195z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#58B146",
    d: "M10.86 30.974l5.432-3.097-5.432-3.099z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005686",
    d: "M10.86 24.779l5.432 3.098v-6.195z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006997",
    d: "M16.291 21.682v6.195l5.432-3.099z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0885BB",
    d: "M21.723 18.585l-5.432 3.097 5.432 3.097z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0099CA",
    d: "M16.291 15.487v6.195l5.432-3.097z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CF1E5C",
    d: "M21.723 12.39l-5.432 3.097 5.432 3.097z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#902C2F",
    d: "M16.291 9.293v6.194l5.432-3.097z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D82333",
    d: "M16.291 9.293L10.86 12.39l5.431 3.097z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2282D",
    d: "M10.86 6.195v6.194l5.432-3.096z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CF323F",
    d: "M10.86 6.195L5.43 9.292l5.43 3.097z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0582D",
    d: "M0 12.39l5.43-3.098L0 6.195z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5722A",
    d: "M0 6.195l5.43 3.097V3.097z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED9B3A",
    d: "M0 0v6.195l5.43-3.098L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5722A",
    d: "M0 12.39l5.43 3.097V9.292z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0582D",
    d: "M5.43 9.292v6.194l5.43-3.096z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C5E5D",
    d: "M32.06 20.115a2.97 2.97 0 0 0-.402-1.475 2.81 2.81 0 0 0-1.065-1.088 2.79 2.79 0 0 0-1.426-.385c-.515 0-1.01.13-1.473.388a2.66 2.66 0 0 0-1.06 1.039c-.248.44-.374.941-.374 1.49 0 .855.275 1.546.84 2.114.564.566 1.235.841 2.052.841.534 0 1.01-.125 1.454-.384.446-.259.792-.61 1.057-1.072.263-.457.396-.951.396-1.468zm.537-3.336c.912.924 1.375 2.058 1.375 3.373 0 1.296-.466 2.419-1.385 3.338-.92.92-2.045 1.386-3.344 1.386a5.21 5.21 0 0 1-2.083-.422c-.65-.281-1.477-.943-1.84-1.388-.591-.726-.882-1.714-.879-2.792l-.003-7.872h1.898v4.016c.29-.239.597-.436.92-.591a4.625 4.625 0 0 1 2.018-.444c1.289 0 2.407.47 3.323 1.396zM34.929 24.775h1.913V12.38h-1.913zM45.404 20.166c0 .524-.129 1.021-.383 1.477A2.606 2.606 0 0 1 44 22.681c-.429.242-.912.364-1.436.364-.521 0-.988-.119-1.426-.364a2.628 2.628 0 0 1-1.027-1.04 2.976 2.976 0 0 1-.386-1.475c0-.82.276-1.5.843-2.078.564-.575 1.217-.854 1.996-.854.78 0 1.432.279 1.996.854.567.578.843 1.258.843 2.078m.669-3.28c-.927-1.003-2.107-1.512-3.508-1.512-1.401 0-2.582.511-3.51 1.521a4.7 4.7 0 0 0-1.257 3.256c0 1.251.446 2.36 1.327 3.295.888.943 2.046 1.422 3.44 1.422 1.39 0 2.545-.478 3.436-1.422.883-.935 1.33-2.044 1.33-3.295a4.711 4.711 0 0 0-1.258-3.265"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C5E5D",
    d: "M54.35 17.159l1.56-2.135H53.6l-.494.671-.016.021-.063.085h.001l-1.926 2.662-1.997-2.768h-2.312l3.156 4.333-3.462 4.747h2.305l2.312-3.181 2.346 3.18h2.336l-3.53-4.748z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C29233",
    d: "M10.86 18.674v3.984l3.493-1.992z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3C338",
    d: "M14.353 16.682l-3.493 1.992 3.493 1.992z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9DC68",
    d: "M10.86 14.69v3.984l3.493-1.991z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C29233",
    d: "M10.86 18.674v3.984l-3.492-1.992z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3C338",
    d: "M7.368 16.682l3.492 1.992-3.492 1.992z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9DC68",
    d: "M10.86 14.69v3.984l-3.492-1.991z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlox);
export default __webpack_public_path__ + "static/media/logo_blox.667d7b1c5a2982b4c220bc982c08c8d5.svg";
export { ForwardRef as ReactComponent };